import React from 'react';
import { MessageSquareText, Tags } from 'lucide-react';
import { AudienceLevel, ConversationRead } from '../../types/pathway';
import { NotesInput } from './NotesInput';
type EntryMode = 'notes' | 'topics';
interface StartPanelProps {
  mode: EntryMode;
  notes: string;
  /** Body of the "Browse Skill Modules" tab — the library filters. */
  topicsContent: React.ReactNode;
  audience: AudienceLevel | 'any';
  liveRead: ConversationRead;
  activeTerms: string[];
  suggestedTerms: string[];
  vocabulary: string[];
  detectedLevel: AudienceLevel | null;
  /** Null until something is matching. */
  matchCount: number | null;
  /** True when there is a search to reset. */
  hasSearch: boolean;
  onReset: () => void;
  onModeChange: (mode: EntryMode) => void;
  onNotesChange: (value: string) => void;
  onAudienceChange: (value: AudienceLevel | 'any') => void;
  onToggleTerm: (term: string) => void;
  onClearNotes: () => void;
  onBrowseAll: () => void;
}
export function StartPanel({
  mode,
  notes,
  topicsContent,
  audience,
  liveRead,
  activeTerms,
  suggestedTerms,
  detectedLevel,
  hasSearch,
  onReset,
  onModeChange,
  onNotesChange,
  onAudienceChange,
  onToggleTerm,
  onClearNotes,
  onBrowseAll
}: StartPanelProps) {
  const tabs: {
    id: EntryMode;
    label: string;
    icon: typeof Tags;
  }[] = [{
    id: 'topics',
    label: 'Browse Skill Modules',
    icon: Tags
  }, {
    id: 'notes',
    label: 'From Conversation Notes',
    icon: MessageSquareText
  }];
  return <div className="rounded-xl border border-gray-100 bg-white shadow-sm" data-id="element-2061" data-mp="2ii1h0g9m18kw">
      <div className="flex border-b border-gray-200 px-5" data-id="element-2062" data-mp="2djq9wdap9c6d">
        {tabs.map(tab => {
        const active = mode === tab.id;
        return <button key={tab.id} type="button" onClick={() => onModeChange(tab.id)} aria-pressed={active} className={active ? 'flex items-center gap-2 border-b-2 border-[#00638C] pb-4 pt-4 pr-6 text-sm font-medium text-[#00638C] transition-colors' : 'flex items-center gap-2 border-b-2 border-transparent pb-4 pt-4 pr-6 text-sm font-medium text-gray-600 transition-colors hover:text-gray-900'} data-id="element-2063" data-mp="24l4swmkvm57p">
              <tab.icon size={16} data-id="element-2064" data-mp="1ncvfgvj0gkxl" />
              {tab.label}
            </button>;
      })}
      </div>

      <div className="p-5" data-id="element-2065" data-mp="1rat9cbnq7v7b">
        {mode === 'topics' ? topicsContent : <NotesInput notes={notes} audience={audience} liveRead={liveRead} activeTerms={activeTerms} suggestedTerms={suggestedTerms} detectedLevel={detectedLevel} hasSearch={hasSearch} onReset={onReset} onNotesChange={onNotesChange} onAudienceChange={onAudienceChange} onToggleTerm={onToggleTerm} onClearNotes={onClearNotes} onBrowseAll={onBrowseAll} data-id="element-2066" data-mp="2f0dqqq48ekeh" />}
      </div>
    </div>;
}